import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'project-page',
    templateUrl: 'project.component.html'
})
export class ProjectComponent implements OnInit {
    @Input('project') project: any;

    constructor() { }

    ngOnInit() {
        console.log("Project: " + JSON.stringify(this.project));
    }

    getKeys(): any {
        let arr = Object.keys(this.project);
        arr.splice(0,2);
        // [key, nice key]
        let keys: any[][] = [];
        for(let key of arr) {
            let splitted:any = key.split(/(?=[A-Z])/); 
            if(splitted.length > 1) {
                let newKey = '';
                for(let part of splitted) {
                    if(part == 'Slash') {
                        newKey += " /";
                    } else {
                        newKey += " " + part;
                    }
                }
                keys.push([key, newKey]);
            } else {
                if(key =="indiener") {
                    splitted = "Indiener"
                }
                keys.push([key, splitted]);
            }
        }


        return keys;
    }
}


// WEBPACK FOOTER //
// ./src/pages/project/project.component.ts